import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { LoadingService } from '../../../core/services/loading.service';

/**
 * A full-screen wait state over requests the user must not fire twice — see {@link BLOCK_UI}.
 *
 * <p>The counterpart to {@link LoadingBar}, not a replacement for it: the bar stays the answer for
 * the portal's many quick reads, and this appears only for a request that opted in. It takes the
 * clicks itself (`pointer-events` is on, unlike the bar), which is the actual protection — a
 * ผู้ยื่นคำขอ pressing ยืนยันการยื่นคำขอ again while the first submit is in flight now hits the
 * overlay.
 *
 * <p>Sits below SweetAlert2 (z-index 1060) so the dialog that reports the outcome is never
 * covered by it, and carries `role="alert"` + `aria-busy` so a screen reader announces the wait
 * rather than leaving the user in silence.
 */
@Component({
  selector: 'app-blocking-overlay',
  template: `
    @if (loading.blocking()) {
      <div class="blocking-overlay" role="alert" aria-busy="true" aria-live="assertive">
        <div class="blocking-overlay__panel">
          <div class="spinner-border text-primary" aria-hidden="true"></div>
          <p class="blocking-overlay__text mb-0">กำลังดำเนินการ กรุณารอสักครู่</p>
        </div>
      </div>
    }
  `,
  styleUrl: './blocking-overlay.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockingOverlay {
  protected readonly loading = inject(LoadingService);
}
